import React from "react";
import UpdateContactInformationContextProvider, {
    UpdateContactInformationContext,
    ACTIONS
} from "../../context/UpdateContactInformationContextProvider";
import Loading from "../../../../common/components/Loading";
import { CGE } from "../../../../common/components/CGE"
import { ClayCheckbox } from "@clayui/form";
import "../../styles/index.scss";
import AlertModal from "../../../../common/components/AlertModal";
import { useModal } from "@clayui/modal";
import BusquedaPrincipal from "../../../busqueda-cliente/components/BusquedaPrincipal/";
import { beforeMaskedValueChangeRut, decode_utf8, isRutValid } from '../../../../common/utils/utilsFunc';
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';


const UpdateContactInformation = ({ props }) => {

    const [state, dispatch] = React.useContext(UpdateContactInformationContext);
    const [loading, setLoading] = React.useState(false);
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [visibleModal, setVisibleModal] = React.useState(false);
    const [visibleModalConfirm, setVisibleModalConfirm] = React.useState(false);
    const [visibleModalSuccess, setVisibleModalSuccess] = React.useState(false);
    const [helpNumCli, setHelpNumCli] = React.useState(false);
    const [successMsg, setSuccessMsg] = React.useState("");
    const [alertMsg, setAlertMsg] = React.useState("");
    const { observer, onClose } = useModal({

        onClose: () => {
            setVisibleModal(false);
            setVisibleModalConfirm(false);
            setVisibleModalSuccess(false);
        },
    });
    //<form
    const [inputForms, setInputForms] = React.useState({
        rut: "",
        name: "",
        numCli: "",
        tel: "",
        email: ""
    });
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        error: {},
        msg: {}
    });
    const [checkOldAge, setCheckOldAge] = React.useState(false);
    const [inputCheckboxes, setInputCheckboxes] = React.useState({
        inter: true,
        sumi: true,
        promo: true,
        serv: true
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    //<form

    function initialState() {
        setInputForms({
            rut: "",
            name: "",
            numCli: "",
            tel: "",
            email: "",
            recaptcha: "",
            checkOldAge: ""
        });
        setInputValidate({
            empty: {},
            error: {},
            msg: {}
        });
        setInputCheckboxes({
            inter: true,
            sumi: true,
            promo: true,
            serv: true
        });
        setCheckOldAge(false);
    }

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function validateForms() {
        let errors = {
            empty: {},
            error: {},
            msg: {}
        };

        if (inputForms.rut) {
            errors.empty.rut = false;

            if (!isRutValid(inputForms.rut)) {
                errors.error.rut = true;
                errors.msg.rut = "Debes ingresar un RUT válido.";
            } else {
                errors.error.rut = false;
            }

        } else {
            errors.empty.rut = true;
            errors.msg.rut = "Debes ingresar el RUT del solicitante.";
        }

        if (inputForms.name) {
            errors.empty.name = false;
        } else {
            errors.empty.name = true;
            errors.msg.name = "Debes ingresar el nombre y apellido";
        }

        if (inputForms.numCli) {
            errors.empty.numCli = false;
            if (inputForms.numCli.length > 12) {
                errors.error.numCli = true;
                errors.msg.numCli = "No puede superar los 12 dígitos en el número cliente";
            } else {
                errors.error.numCli = false;
            }

        } else {
            errors.empty.numCli = true;
            errors.msg.numCli = "Debes ingresar el número cliente";
        }

        if (inputForms.tel) {
            errors.empty.tel = false;

            if (inputForms.tel.length > 9) {
                errors.error.tel = true;
                errors.msg.tel = "No puede superar los 9 dígitos en el telefono";
            } else if (inputForms.tel.length < 9) {
                errors.error.tel = true;
                errors.msg.tel = "No puede ser inferior a los 9 dígitos en el telefono";

            } else {
                errors.error.tel = false;

            }

        } else {
            errors.empty.tel = true;
            errors.msg.tel = "Debes ingresar el teléfono de contacto";
        }

        if (inputForms.email) {
            errors.empty.email = false;
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputForms.email)) {
                errors.error.email = true;
                errors.msg.email = "Debes ingresar un email válido";
            } else {
                errors.error.email = false;
            }

        } else {
            errors.empty.email = true;
            errors.msg.email = "Debes ingresar el email de contacto";
        }

        setInputValidate(errors);
        return errors;
    }

    function funcSend() {
        const objErros = validateForms();
        let errorMsgLocal = Object.values(objErros?.msg).toString().replaceAll(",", ". ");

        if (errorMsgLocal) {
            props.setGlobalAlert("Complete todos los campos obligatorios", "warning");
            return;
        } else if (!verifReCaptcha) {
            props.setGlobalAlert("Falta validar que no eres un Robot.", "warning");
        } else if (!checkOldAge) {
            props.setGlobalAlert("Debes marcar que los datos son fidedignos y es mayor de 18 años", "warning");

        }
        else {
            setLoading(true);
            dispatch({
                payload: inputForms.numCli,
                type: ACTIONS.SET_CTA_CTO,
            });
        }
    }

    function funcConfirm() {
        setVisibleModal(false);
        dispatch({
            payload: {
                rutUsuario: inputForms.rut,
                nroCliente: inputForms.numCli,
                telefono: inputForms.tel,
                email: inputForms.email,
                nombreCompleto: inputForms.name,
                notifPromocion: inputCheckboxes.promo,
                notifServicio: inputCheckboxes.serv,
                notifSuministro: inputCheckboxes.sumi
            },
            type: ACTIONS.SET_FORM,
        });
        setLoading(true);
    }


    React.useEffect(() => {
        setLoading(false);
        setVisibleModalSuccess(false);
        setVisibleModalConfirm(false);
        const objRespServ2 = state?.response_serv2;

        if (objRespServ2?.code >= 0) {
            if (objRespServ2?.code === 0) {
                setVisibleModalSuccess(true);
                setSuccessMsg(objRespServ2?.message);
                initialState();
            } else {
                props.setGlobalAlert(objRespServ2?.message, "warning", true, "Advertencia");

            }
        }

    }, [state.response_serv2])

    React.useEffect(() => {
        setLoading(false);
        setVisibleModalConfirm(false);
        const objRespServ1 = state?.response_serv1?.ConsultarDetalleCtaCtoResponse;
        if (objRespServ1?.RETORNO) {

            if (objRespServ1.RETORNO?.RETURN === 0) {

                dispatch({
                    payload: null,
                    type: ACTIONS.SET_FORM,
                });
                dispatch({
                    payload: null,
                    type: ACTIONS.SET_CTA_CTO,
                });

                let auxDir = "";
                if (objRespServ1?.ITEM?.COMUNA) {
                    auxDir += objRespServ1?.ITEM?.COMUNA;
                }
                if (objRespServ1?.ITEM?.CALLE) {
                    auxDir += ", " + objRespServ1?.ITEM?.CALLE;
                }
                if (objRespServ1?.ITEM?.NUMERO_CASA) {
                    auxDir += ", " + objRespServ1?.ITEM?.NUMERO_CASA;
                }
                if (objRespServ1?.ITEM?.EDIFICIO) {
                    auxDir += ", " + objRespServ1?.ITEM?.EDIFICIO;
                }

                setAlertMsg("Por favor verificar que los datos están correctos y que la dirección del servicio mostrada corresponde al número de cliente ingresado. ¿Desea enviar los datos? Dirección: " + auxDir);
                setVisibleModalConfirm(true);
            } else {
                props.setGlobalAlert(objRespServ1.RETORNO?.TEXTO_RETURN, "warning", true, "Advertencia");

            }
        }
        if (objRespServ1 && objRespServ1?.status !== 200 && !objRespServ1?.RETORNO) {
            props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
        }

    }, [state.response_serv1]);

    return (
        <div
            id="container"
        >
            <CGE.Panel title={decode_utf8(props.titulo_actualizacion_de_datos_de_contacto)}>
                <CGE.RenderContent textContent={state?.webContentTextTitle} />
                <CGE.Spacing type="gn" />
                <CGE.PanelContainer
                    size="lg" alingItensCenter={true}>
                    <CGE.FormsField
                        horizontal={true}
                        labelName="Rut"
                        handleChange={({ target }) => {
                            setInputForms({ ...inputForms, rut: target.value })
                        }}
                        idFormElement="inputRut"
                        typeFormElement="text"
                        mandatoryElement={true}
                        hasError={inputValidate.error.rut || inputValidate.empty.rut}
                        msgError={inputValidate.msg.rut}
                        value={inputForms.rut}
                        typeElement="input-mask"
                        beforeMaskedValueChange={beforeMaskedValueChangeRut}
                        formatChars={{
                            "9": "[0-9]",
                            k: "[Kk0-9]",
                        }}
                        mask="9.999.999-kk"
                    />

                    <CGE.FormsField
                        horizontal={true}
                        labelName="Nombre y apellidos"
                        handleChange={({ target }) => {
                            setInputForms({ ...inputForms, name: target.value })
                        }}
                        idFormElement="inputName"
                        typeFormElement="text"
                        typeElement="input"
                        mandatoryElement={true}
                        hasError={inputValidate.error.name || inputValidate.empty.name}
                        msgError={inputValidate.msg.name}
                        value={inputForms.name}
                    />
                    <div className="resp-mb-4-child">
                        <CGE.FormsField
                            className="grid-1"
                            horizontal={true}
                            labelName="Número cliente"
                            handleChange={({ target }) => {
                                setInputForms({ ...inputForms, numCli: target.value });
                                const inputNumCliente = document.getElementById("inputNumCli");
                                inputNumCliente.addEventListener("focusout", () => {
                                    if (target.value && helpNumCli) {
                                        setHelpNumCli(false)
                                    }
                                });
                            }}
                            idFormElement="inputNumCli"
                            typeFormElement="text"
                            typeElement="input"
                            mandatoryElement={true}
                            hasError={inputValidate.error.numCli || inputValidate.empty.numCli}
                            msgError={inputValidate.msg.numCli}
                            value={inputForms.numCli}
                        />
                        <a
                            onClick={() => setVisibleModal(true)}
                            className="grid-2 resp-align-items-center"
                        >
                            <CGE.Icon style={{ fontSize: "40px" }} name="question-circle-o" />
                        </a>
                    </div>
                    <CGE.Button type="ghost" className="pt-0 pl-0 " label="Si no conece su numero cliente haga click AQUI" onClick={() => { setHelpNumCli(!helpNumCli) }} />
                    <CGE.Spacing type="md" />
                    {helpNumCli &&
                        <>
                            <div className="border rounded">
                                <BusquedaPrincipal
                                    hideSearch={setHelpNumCli}
                                    changeInputNumClient={setInputForms}
                                    inputForms={inputForms}
                                    setGlobalAlert={props.setGlobalAlert}
                                    containerSize="lg"
                                />
                            </div>
                            <CGE.Spacing type="nl" />
                        </>
                    }
                    <CGE.FormsField
                        horizontal={true}
                        labelName="Teléfono"
                        handleChange={({ target }) => {
                            setInputForms({ ...inputForms, tel: target.value });
                        }}
                        minLength="9"
                        maxLength="9"
                        idFormElement="inputTel"
                        typeFormElement="text"
                        typeElement="input-mask"
                        formatChars={{
                            9: "[0-9]",
                        }}
                        mask="999999999"
                        placeholder="(Ej: 912345678)"
                        mandatoryElement={true}
                        hasError={inputValidate.error.tel || inputValidate.empty.tel}
                        msgError={inputValidate.msg.tel}
                        value={inputForms.tel}
                    />

                    <CGE.FormsField
                        horizontal={true}
                        labelName="Correo electrónico"
                        handleChange={({ target }) => {
                            setInputForms({ ...inputForms, email: target.value });
                        }}
                        idFormElement="inputEmail"
                        typeFormElement="text"
                        typeElement="input"
                        mandatoryElement={true}
                        hasError={inputValidate.error.email || inputValidate.empty.email}
                        msgError={inputValidate.msg.email}
                        value={inputForms.email}
                    />
                </CGE.PanelContainer>
                <CGE.Spacing type="gn" />
                <div className=" resp-label-size">
                    <ClayCheckbox
                        checked={checkOldAge}
                        onChange={() => setCheckOldAge(val => !val)}
                        className="class-test"
                        label="Declaro que los datos aportados son fidedignos y que soy mayor de 18 años"
                    />
                </div>
                <CGE.Spacing type="nl" />
                <div className="">
                    <CGE.Text text="Autorizo que estos datos sean usados para:" style={{ fontWeight: 600 }} size="3" />
                    <ClayCheckbox
                        disabled={true}
                        checked={inputCheckboxes.inter}
                        label="Información de interrupciones"
                    />
                    <ClayCheckbox
                        checked={inputCheckboxes.sumi}
                        onChange={() => setInputCheckboxes({ ...inputCheckboxes, sumi: !inputCheckboxes.sumi })}
                        label="Notificación de suministro"
                    />
                    <ClayCheckbox
                        checked={inputCheckboxes.promo}
                        onChange={() => setInputCheckboxes({ ...inputCheckboxes, promo: !inputCheckboxes.promo })}
                        label="Notificación de promociones"
                    />
                    <ClayCheckbox
                        checked={inputCheckboxes.serv}
                        onChange={() => setInputCheckboxes({ ...inputCheckboxes, serv: !inputCheckboxes.serv })}
                        label="Notificación de servicios"
                    />
                </div>
                <CGE.PanelContainer
                    size="md" alingItensCenter={true}
                >
                    <CGE.FieldRecaptcha
                        onChange={onChangeReCaptcha}
                        sitekey={props.api_key_recaptcha}
                        horizontal={true}
                    />
                </CGE.PanelContainer>
                <div className="d-flex flex-column align-items-center">
                    <CGE.Button
                        label="Enviar"
                        onClick={() => { funcSend() }}
                        type="primary"
                    />
                </div>
            </CGE.Panel>
            {visibleModal && !loading && (
                <AlertModal
                    titleModal="Información"
                    observer={observer}
                    onClose={onClose}
                    status="info"
                >
                    <CGE.RenderContent textContent={state?.webContentTextInfo} />
                </AlertModal>
            )}
            {visibleModalConfirm && !loading && (
                <AlertModal
                    titleModal="Información"
                    observer={observer}
                    onClose={onClose}
                    msgModal={alertMsg}
                    status="info"
                    funcClick={() => {
                        funcConfirm()
                    }}
                    confirm={true}
                />
            )}
            {visibleModalSuccess && !loading && (
                <AlertModal
                    titleModal={"Confirmación"}
                    msgModal={successMsg}
                    observer={observer}
                    onClose={onClose}
                    status="success"
                />
            )}
            {loading && <Loading />}
        </div>
    );
};

const UpdateContactInformationWithProvider = ({ props }) => (
    <UpdateContactInformationContextProvider>
        <UpdateContactInformation props={props} />
    </UpdateContactInformationContextProvider>
);
export default UpdateContactInformationWithProvider;